<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <div
          class="alert alert-success p-4 mb-4 d-flex flex-column flex-xxl-row"
        >
          <div class="m-xxl-2">
            <h3>Order Successful!</h3>
            <p class="lead">
              Passes valid until
              {{ $moment(passesExpire).format("DD/MM/YYYY") }}
            </p>
            <p>
              Thank you for your purchase. A confirmation email has been sent to
              your email address.
            </p>
            <p>
              Next steps:
            </p>
            <ol>
              <li>
                <component :is="inductionComplete ? 'del' : 'span'">
                  Complete the
                  <router-link to="/induction" class="text-secondary"
                    ><strong>WHS Induction.</strong></router-link
                  >
                </component>
                <md-button
                  v-if="!inductionComplete"
                  class="md-white"
                  @click="$router.push('/induction')"
                >
                  Click here to complete the induction form
                </md-button>
              </li>
              <li>
                Visit {{ offices }} with a valid form of ID
                <strong>(Driver's License / Passport).</strong>
              </li>
              <li>
                Smile for the camera – have your photo taken and your pass
                issued.
              </li>
              <li>
                <a
                  href="https://www.sydneymarkets.com.au/sml-traders-app.html"
                  target="_blank"
                  class="text-secondary"
                  ><strong>Download the SML Trader app</strong></a
                >
                to receive important notifications and up-to-date
                information.<br />
                <a
                  href="https://apps.apple.com/au/app/sml-trader/id1217341213"
                  target="_blank"
                >
                  <img
                    src="@/assets/icons/icon_App-Store.svg"
                    class="img-fluid m-1"
                    style="width: 150px;"
                    alt="app store"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.schoolenews.sydneymarkets2129&hl=en&gl=US"
                  target="_blank"
                >
                  <img
                    src="@/assets/icons/icon_Google-Play.png"
                    class="img-fluid m-1"
                    style="width: 150px;"
                    alt="google play"
                  />
                </a>
              </li>
            </ol>
            <p>
              Remember to ‘Like’ us on Facebook and follow
              <strong>@sydneymarkets</strong>
              on Instagram.
            </p>
            <div>
              <md-button
                v-if="inductionComplete"
                class="md-white"
                @click="$router.push('/dashboard')"
              >
                Go to Dashboard
              </md-button>
              <md-button
                class="md-secondary mx-2"
                target="_blank"
                :href="lastPurchase[0].receipt_pdf"
              >
                Download Invoice
              </md-button>
            </div>
          </div>
          <div class="flex-grow-1 flex-shrink-0">
            <img
              :src="require(`@/assets/img/maps/${map}.jpg`)"
              width="600"
              alt="office map"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      passesExpire: "",
      passTypes: []
    };
  },
  computed: {
    bothPasses() {
      return (
        this.passTypes?.includes("general_and_flower") ||
        this.passTypes?.length > 1
      );
    },
    general() {
      return this.passTypes.includes("general");
    },
    inductionComplete() {
      return this.authUser?.induction_complete;
    },
    map() {
      if (this.bothPasses) {
        return "map-general_flower";
      } else if (this.general) {
        return "map-general";
      } else {
        return "map-flower";
      }
    },
    offices() {
      let text = "";
      if (this.general || this.bothPasses) {
        text += "the Market Central Office";
      }
      if (this.bothPasses) {
        text += " and ";
      }
      if (this.bothPasses || !this.general) {
        text += "the Flower Market Office";
      }
      return text;
    },
    ...mapGetters(["authUser", "lastPurchase"])
  },
  created() {
    if (this.$store.getters.lastPurchase.count === 0) {
      this.$router.push("/dashboard");
    }
  },
  mounted() {
    this.passesExpire = this.lastPurchase[0].expires_at;
    this.passTypes = this.lastPurchase
      .map(pass => pass["type"])
      .filter((value, index, self) => self.indexOf(value) === index);
  }
};
</script>
